<template>
  <div class="box">
    <div class="container">
      <h1>{{$t('竞赛物联网')}}</h1>
      <p>{{$t('为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通')}}</p>
      <div class="content">
        <div class="img-a">
          <div class="img1">
            <br/>
            <img src="../../../assets/internetimg/1.png" style="height:55px"/><br/><br/>
            <span class="font1">{{$t('裁判打分手柄/技术平板')}}</span>
          </div>
          <div class="img-b">
            <img src="../../../assets/internetimg/2.png" style="height:85px"/><br/><br/>
            <span class="font2">{{$t('运动员穿戴设备、竞赛硬件设备')}}</span>
          </div>
          <div class="img-c">
            <img src="../../../assets/internetimg/3.png" style="height:83px"/><br/><br/>
            <span class="font3">{{$t('录像审议视频采集')}}</span>
          </div>
        </div>
        <div class="img-d">
          <div class="height_1" :style="{height: height_1 + 'px'}"></div>
          <div class="height_2" :style="{width: width_2 + 'px'}"></div>
          <div class="height_3" :style="{height: height_3 + 'px'}"></div>
          <div class="height_4" :style="{width: '425px'}">
            <div class="height_b" :style="{width: '425px',left: width_4 + 'px'}"></div>
          </div>
          <div class="height_5" :style="{height: height_5 + 'px'}"></div>
        </div>
        <div class="img-e">
          <span class="font4">检录处发送检录通知</span>
          <span class="font5">现场终端</span>
          <div class="height_8" :style="{width: '290px'}">
            <div class="height_c" :style="{width: '290px',left: width_8 + 'px'}"></div>
          </div>
          <div class="height_7" :style="{height: height_7 + 'px'}"></div>
          <span class="font6">{{$t('记时记分比赛投屏')}}</span>
          <div class="height_6" :style="{width: width_6 + 'px'}"></div>
          <img class="e-1" src="../../../assets/internetimg/4.png"/>
          <img class="e-2" src="../../../assets/internetimg/xinhao.gif"/>
          <img class="e-3" src="../../../assets/internetimg/5.png"/>
          <div class="height_9" :style="{height: height_9 + 'px'}"></div>
        </div>
        <div style="width:900px;margin:0 auto;height:60px;position: relative;">
          <div class="height_10" :style="{width: '430px'}">
            <div class="height_d" :style="{width: '430px', left: width_10 + 'px'}"></div>
          </div>
          <div class="height_11" :style="{width: width_11 + 'px'}"></div>
          <div class="height_12" :style="{height: height_12 + 'px'}"></div>
          <div class="height_13" :style="{height: height_13 + 'px'}"></div>
          <div class="height_14" :style="{height: height_14 + 'px'}"></div>
          <div class="height_15" :style="{height: height_15 + 'px'}"></div>
        </div>
        <div class="img-f">
          <span class="font-7">{{$t('比赛进程')}}</span>
          <img class="img-f1" src="../../../assets/internetimg/6.png"/>
          <span class="font-8">{{$t('成绩、人气排行榜')}}</span>
          <img class="img-f2" src="../../../assets/internetimg/7.png"/>
          <span class="font-9">{{$t('技术统计数据分析')}}</span>
          <img class="img-f3" src="../../../assets/internetimg/8.png"/>
          <span class="font-10">{{$t('比赛直播')}}</span>
          <img class="img-f4" src="../../../assets/internetimg/9.png"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataInternet',
  components: {},
  mounted () {
    let that = this
    let first = true
    let twoCal = false
    let threeCal = false
    setInterval(function () {
      if (first) {
        if (that.height_1 <= 50) {
          that.height_1++
          that.height_5++
        } else if (that.width_2 < 455) {
          that.width_2++
          that.width_4--
          if (that.width_4 <= 50) {
            that.height_3++
          }
        }
        if (that.height_3 >= 50) {
          if (first) {
            that.height_9 = 0
            that.width_10 = 430
            that.width_11 = 0
            that.height_12 = 0
            that.height_13 = 0
            that.height_14 = 0
            that.height_15 = 0
          }
          twoCal = true
          first = false
        }
      }

      if (twoCal) {
        that.width_6++
        that.height_7++
        if (that.height_7 >= 70) {
          that.height_7 = 70
        }
        that.width_8--
        if (that.width_6 >= 290) {
          twoCal = false
          threeCal = true
        }
      }
      if (threeCal && !first) {
        that.height_9++
        if (that.height_9 >= 130) {
          that.height_9 = 130
          that.width_10--
          if (that.width_10 <= 0) {
            that.width_10 = 0
          }
          that.width_11++
          if (that.width_11 >= 160) {
            that.height_13++
            that.height_14++
            if (that.height_13 >= 50) {
              that.height_13 = 50
              that.height_14 = 50
            }
          }
          if (that.width_11 >= 430) {
            that.width_11 = 430
            that.height_12++
            that.height_15++
            if (that.height_12 >= 50) {
              that.height_12 = 50
              that.height_15 = 50

              that.height_1 = 0
              that.width_2 = 0
              that.height_3 = 0
              that.width_4 = 425
              that.height_5 = 0
              first = true

              that.width_6 = 0
              that.height_7 = 0
              that.width_8 = 290

              threeCal = false
            }
          }
        }
      }
    }, 1)
  },
  data () {
    return {
      height_1: 0,
      width_2: 0,
      height_3: 0,
      width_4: 425,
      height_5: 0,
      width_6: 0,
      height_7: 0,
      width_8: 290,
      height_9: 0,
      width_10: 430,
      width_11: 0,
      height_12: 0,
      height_13: 0,
      height_14: 0,
      height_15: 0
    }
  },
  computed: {},
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 100%;
  position: relative;
  top:-70px;
}
.container{
  width: 100%;
  height: 700px;
  background-image: url('../../../assets/internetbg.jpg');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: 70px;
  margin-bottom: 60px;
}
.container h1{
  text-align: center;
  margin-top: 50px;
}
.container p{
  text-align: center;
}
.content{
  width: 1200px;
  margin: 0 auto;
  position: relative;
  height: 459px;
}
.height_1{
  height:50px;width:2px;margin-left:20px;background: rgb(87, 189, 207);
  position: absolute;
}
.height_2{
  height:2px;width:430px;margin-left:20px;background: rgb(87, 189, 207);
  position: absolute;
  top: 50px;
}
.height_3{
  height:50px;width:2px;margin-left:70px;background: rgb(87, 189, 207);
  position: absolute;
  left: 375px;
  top: 2px;
}
.height_4{
  height:2px;width:406px;margin-left:70px;
  position: absolute;
  left: 375px;
  top: 50px;
  overflow: hidden;
}
.height_b{
  height:2px;width:406px;background: rgb(87, 189, 207);
  position: absolute;
  left: 375px;
  top: 0px;
}
.height_5{
  height:50px;width:2px;margin-left:70px;background: rgb(87, 189, 207);
  position: absolute;
  right: 28px;
  top: 1px;
}
.height_6{
  height:2px;width:260px;margin-left:500px;background: rgb(87, 189, 207);
  position: absolute;
  top: 15px;
}
.height_7{
  height:50px;width:2px;margin-left:70px;background: rgb(87, 189, 207);
  position: absolute;
  left: 375px;
  top: -70px;
}
.height_8{
  height:2px;width:290px;margin-left:80px;
  position: absolute;
  left: 28px;
  top: 15px;
  overflow: hidden;
}
.height_c{
  height:2px;width:290px;background: rgb(87, 189, 207);
  position: absolute;
  left: 0px;
  top: 0px;
}
.height_9{
  height:50px;width:2px;margin-left:70px;background: rgb(87, 189, 207);
  position: absolute;
  left: 375px;
  top: 42px;
  z-index: 1;
}
.height_10{
  height:2px;width:430px;margin-left:80px;
  position: absolute;
  left: -60px;
  top: 10px;
  overflow: hidden;
}
.height_d{
  height:2px;width:430px;background: rgb(87, 189, 207);
  position: absolute;
  left: 0px;
  top: 0px;
}
.height_11{
  height:2px;width:260px;margin-left:160px;background: rgb(87, 189, 207);
  position: absolute;
  top: 10px;
  left: 287px;
}
.height_12{
  height:50px;width:2px;margin-left:19px;background: rgb(87, 189, 207);
  position: absolute;
  top: 10px;
}
.height_13{
  height:50px;width:2px;margin-left:275px;background: rgb(87, 189, 207);
  position: absolute;
  top: 10px;
}
.height_14{
  height:50px;width:2px;margin-left:620px;background: rgb(87, 189, 207);
  position: absolute;
  top: 10px;
}
.height_15{
  height:50px;width:2px;margin-left:877px;background: rgb(87, 189, 207);
  position: absolute;
  top: 10px;
}
.img-a{
  width:1000px;margin:0 auto;height:120px;
}
.img1{
  width:350px;float:left;height:120px;
}
.font1{
  padding:5px 15px;background:gray;border-radius:5px;color:white;
}
.img-b{
  width:290px;float:left;height:120px;text-align: center;
}
.font2{
  padding:5px 15px;background:gray;border-radius:5px;color:white;
}
.img-c{
  width:290px;float:right;height:120px;text-align: right;
}
.font3{
  padding:5px 15px;background:gray;border-radius:5px;color:white;
}
.img-d{
  width:900px;margin:0 auto;height:120px;position: relative;margin-top: 10px;
}
.img-e{
  width:900px;margin:0 auto;height:160px;position: relative;
}
.font4{
  padding:5px 15px;background:gray;border-radius:5px;color:white;position: absolute;top: 0px;left: -50px;
}
.font5{
  padding:10px 20px;background:gray;border-radius:5px;color:white;position: absolute;top: 0px;left: 400px;
}
.font6{
  padding:5px 23px;background:gray;border-radius:5px;color:white;position: absolute;top: 0px;right: -50px;
}
.e-1{
  height:90px;position: absolute;top: 50px;left: -55px;
}
.e-2{
  height:70px;position: absolute;top: 70px;left:340px;z-index:2;
}
.e-3{
  height:90px;position: absolute;right: -50px;top: 50px;
}
.img-f{
  width:1000px;margin:0 auto;height:120px;position: relative;
}
.font-7{
  padding:5px 30px;background:gray;border-radius:5px;color:white;position: absolute;top: 5px;left: 0;
}
.img-f1{
  height:150px;position: absolute;left: -15px;top: 40px;
}
.font-8{
  padding:5px 30px;background:gray;border-radius:5px;color:white;position: absolute;top: 5px;left: 245px;
}
.img-f2{
  height:150px;position: absolute;left: 255px;top: 40px;
}
.font-9{
  padding:5px 30px;background:gray;border-radius:5px;color:white;position: absolute;top: 5px;left: 587px;
}
.img-f3{
  height:150px;position: absolute;left: 598px;top: 40px;
}
.font-10{
  padding:5px 10px;
  background:gray;
  border-radius:5px;color: white;
  position: absolute;
  top: 5px;left: 884px;
}
.img-f4{
  height:150px;position: absolute;left: 870px;top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/DataInternet.vue